import cashier, { type CashierModel } from './cashier';
import config, { type ConfigModel } from './config';
import domain, { type DomainModel } from './domain';
import modActivity, { type ModActivityModel } from './modActivity';
import notification, { type NotificationModel } from './notification';
import publicSettings, { type PublicSettingsModel } from './publicSettings';
import report, { type ReportModel } from './report';
import search, { type SearchModel } from './search';
import shortUrl, { type ShortUrlModel } from './short-url';
import superComment, { type SuperCommentModel } from './super-comment';
import token, { type TokenModel } from './token';
import tokenPrice, { type TokenPriceModel } from './token-price';
import user, { type UserModel } from './user';
import voting, { type VotingModel } from './voting';
import wallet, { type WalletModel } from './wallet';

export interface StoreModel {
    user: UserModel;
    token: TokenModel;
    tokenPrice: TokenPriceModel;
    voting: VotingModel;
    config: ConfigModel;
    notification: NotificationModel;
    domain: DomainModel;
    publicSettings: PublicSettingsModel;
    cashier: CashierModel;
    wallet: WalletModel;
    report: ReportModel;
    search: SearchModel;
    modActivity: ModActivityModel;
    superComment: SuperCommentModel;
    shortUrl: ShortUrlModel;
}

export interface StoreModelSetPayload<T> {
    key: keyof T;
    value: unknown;
}

const storeModel: StoreModel = {
    user,
    token,
    tokenPrice,
    voting,
    config,
    notification,
    domain,
    publicSettings,
    cashier,
    wallet,
    report,
    search,
    modActivity,
    superComment,
    shortUrl,
};

export default storeModel;
